import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material";
import { CommunicationData } from "../../services/communicationdata.service";

@Component({
  selector: "ya-languagedialog",
  templateUrl: "./languageDialog.component.html",
  styleUrls: ["./languageDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageDialogComponent implements OnInit {
  public languages: string[];

  constructor(public bottomSheetRef: MatBottomSheetRef<LanguageDialogComponent>,
    private _communicationData: CommunicationData) {
  }

  ngOnInit() {
    const me = this;
    me.languages = ["de", "en"];
  }

  public setLanguage(lng: string): void {
    const me = this;
    me._communicationData.setLanguageChoice(lng);
    me.bottomSheetRef.dismiss();
  }
}
